export enum PermissionErrorType {
  NoError,
  UnknownError,
  CantPayToClient,
  CantReceiveFromClient,
  CantPayToCentralBox,
  CantReceiveFromCentralBox,
  ExceededAllowedMaxTransactionValue,
  CantDeleteExternalTransaction,
  CantChangePrice,
  CantSellInDebt,
  CantDeleteAnItem,
  CantReduceQuantity,
  CantViewSettledTransactions,
  CantReprintSettledTransaction,
  CantOpenDrawerManually,
  CantMakeDiscountOnItem,
  CantMakeDiscountOnTransaction,
  CantUseFc,
  CantPayForReturnsInFc,
  CantModifyExchangeRates,
  CantCloseShift,
  CantViewCalculatedCash,
  CantPrintShiftSummary,
  CantPostCashToNextShift,
  CantUnCloseShift,
  CantViewCustomerBalanceStatement,
  CantShowCustomerBalance,
  CantViewCalculatedCashDetails,
  CantViewCalculatedNonCashDetails,
  CantViewShiftDigest,
  CantViewMaterialsAndServicesTransactionsDetail,
  CantViewExternalTransactionsDetails,
  CantViewClosingDetails,
  CantChangeCentralBoxReceiptNumberMandatory,
  // Order
  CantAddPickUpOrder,
  CantAddDeliveryOrder,
  CantEditDeliveryFees,
  CantReceivePrepayment,
  CantCancelOrder,
  CantEditSavedOrder,
  CantUseOrderManagementTab,
  CantUseDeliveryOrdersManagement,
  CantSettlePickupOrder,
  CantSettleDeliveryTrip,
  CantHandleTableOrder,
  CantSettleTableOrder,
  // Client
  CantAddNewClient,
  CantModifyExistingClient,
  CantChangeDefaultCountryAndProvince,
  CantAddNewAddress,
  CantModifyAddress,
  // Menus
  CantChangeMenu,
  CantUseMenuOutsideOperatingHours,
  CantChangeMenuWhenOpenOrder,
  // PreparingAndServing
  CantCancelOrderAfterPreparationStarts,
  CantCancelOrderAfterServed,
  CantCancelItemAfterPreparationStarts,
  CantCancelItemAfterServed,
  CantChangeItemQuantityAfterPreparationStarts,
  CantChangeItemQuantityAfterServed,
  CantReturnOrderFromInPreparation,
  CantEndPreparationInKitchenWindow,
  CantMoveOrder,
  CantMoveOrderItems,
  CantPrintCustomizationBeforeCollect,
  CantSendEReceipt,
}

export interface IPermissionResponse {
  response: boolean;
  error: PermissionErrorType;
}

export enum PermissionType {
  NONE,
  ChangePrice,
  SellInDebt,
  DeleteAnItem,
  ReduceQuantity,
  ViewSettledTransactions,
  ReprintSettledTransaction,
  OpenDrawerManualy,
  MakeDiscountOnItem,
  MakeDiscountOnTransaction,
  CanUseFc,
  CanPayForReturnsInFc,
  CanModifyExChangeRates,
  CanCloseShift,
  CanViewCalculatedCash,
  CanPrintShiftSummary,
  CanPostCashToNextShift,
  CanUnCloseShift,
  CanViewCustomerBalanceStatement,
  CanShowCustomerBalance,
  CanViewCalculatedCashDetails,
  CanViewCalculatedNonCashDetails,
  CanViewShiftDigest,
  CanViewMaterialsAndServicesTransactionsDetail,
  CanViewExternalTransactionsDetails,
  CanViewClosingDetails,
  CanChangeCentralBoxReceiptNumberMandatory,
  CanDeleteExternalOperation,
  // Order
  CanAddPickUpOrder,
  CanAddDeliveryOrder,
  CanEditDeliveryFees,
  CanReceivePrepayment,
  CanCancelOrder,
  CanEditSavedOrder,
  CanUseOrderManagementTab,
  CanUseDeliveryOrdersManagement,
  CanSettlePickupOrder,
  CanSettleDeliveryTrip,
  CanHandleTableOrder,
  CanSettleTableOrder,
  // Client
  CanAddNewClient,
  CanModifyExistingClient,
  CanChangeDefaultCountryAndProvince,
  CanAddNewAddress,
  CanModifyAddress,
  // Menus
  CanChangeMenu,
  CanChangeMenuWhenOpenOrder,
  // PreparingAndServing
  CanCancelOrderAfterPreparationStarts,
  CanCancelOrderAfterServed,
  CanCancelItemAfterPreparationStarts,
  CanCancelItemAfterServed,
  CanChangeItemQuantityAfterPreparationStarts,
  CanChangeItemQuantityAfterServed,
  CanReturnOrderFromInPreparation,
  CanEndPreparationInKitchenWindow,
  CanPayToClient,
  CanReceiveFromClient,
  CanPayToCentralBox,
  CanReceiveFromCentralBox,
  CanMoveOrder,
  CanMoveOrderItems,
  CanPrintCustomizationBeforeCollect,
  SendEReceipt,
  //Units
  EDIT_STANDARD_UNITS_GROUP,
}
